<template>
  <div>
    <div class="tips">
      <span class="tips-text2">*{{ $t("message.messageMsg.mobileButlerTips") }}</span>
    </div>
    <!-- 删除配置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.mobileButlerMsg.deleteConfiguration") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.clearAllConfig") }}:</span>
        <el-select size="medium" v-model="m.DeleteConfig.delete_all">
          <el-option :label="$t('common.open')" :value="true"></el-option>
          <el-option :label="$t('common.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.clearAppConfig") }}:</span>
        <el-select size="medium" v-model="m.DeleteConfig.delete_app_info">
          <el-option :label="$t('common.open')" :value="true"></el-option>
          <el-option :label="$t('common.close')" :value="false"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <!-- 应用列表 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.mobileButlerMsg.desktopAppList") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.addApp") }}:</span>
        <el-button type="text" @click="openAddAppDialog">{{ $t("common.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="m.AppList?.length">
          <el-tag id="tag-box" v-for="(v, i) in m.AppList" :key="i" closable @close="handleAppClose(i)">
            {{
              v.AppInfo?.package_name?.length > 30
                ? v.AppInfo?.package_name?.substring(0, 29) + "..."
                : v.AppInfo?.package_name
            }}
          </el-tag>
        </div>
      </el-col>
    </el-row>

    <!-- 自启动应用 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.mobileButlerMsg.autoStartApp") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">Package Name :</span>
        <el-input size="medium" v-model="m.auto_start_app.package_name" :placeholder="$t('common.pleaseInput')" />
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">Class Name :</span>
        <el-input size="medium" v-model="m.auto_start_app.class_name" :placeholder="$t('common.pleaseInput')" />
      </el-col>
    </el-row>

    <!-- 基础设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t("message.mobileButlerMsg.basicSettings") }}</span>
      </el-col>
      <!-- 账号信息 -->
      <el-col :span="24">
        <span class="secondfont-title">{{ $t("message.mobileButlerMsg.accountInfo") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.username") }}:</span>
        <el-input size="medium" v-model="m.Setting.account_info.user_name" :placeholder="$t('common.pleaseInput')" />
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.password") }}:</span>
        <el-input size="medium" v-model="m.Setting.account_info.password" :placeholder="$t('common.pleaseInput')" show-password />
      </el-col>
      <!-- 屏保设置 -->
      <el-col :span="24">
        <span class="secondfont-title">{{ $t("message.mobileButlerMsg.screenSaverSettings") }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.question") }}:</span>
        <el-input size="medium" v-model="m.Setting.password_protection.question" :placeholder="$t('common.pleaseInput')" />
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.answer") }}:</span>
        <el-input size="medium" v-model="m.Setting.password_protection.answer" :placeholder="$t('common.pleaseInput')" />
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.answerEncryptionType") }}:</span>
        <el-select size="medium" v-model="m.Setting.password_protection.answer_type">
          <el-option label="ORIGINAL" value="ORIGINAL"></el-option>
          <el-option label="MD5" value="MD5"></el-option>
        </el-select>
      </el-col>
      <!-- 其他设置 -->
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.allowNewAppAdd") }}:</span>
        <el-select size="medium" v-model="m.Setting.allow_new_app_auto_add">
          <el-option :label="$t('common.open')" :value="true"></el-option>
          <el-option :label="$t('common.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.mobileButlerMsg.bootStartup") }}:</span>
        <el-select size="medium" v-model="m.Setting.boot_startup">
          <el-option :label="$t('common.open')" :value="true"></el-option>
          <el-option :label="$t('common.close')" :value="false"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <!-- 壁纸设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.display.002') }}
        </span>
      </el-col>
       <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("messageAdd.display.002") }}:</span>
        <el-button type="text" @click="manageWallpaper">{{ $t('messageAdd.display.003') }}</el-button>
      </el-col>
    </el-row>

    <!-- 壁纸设置弹框 -->
    <el-dialog :title="$t('messageAdd.display.002')" :visible.sync="wallpaperDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeWallpaperDialog">
      <el-form ref="WallpaperForm" label-width="160px" :model="wallpaperForm" :rules="wallpaperRules">
        <el-form-item :label="$t('messageAdd.display.004')" prop="t">
          <el-radio-group v-model="wallpaperForm.t"  @input="handleWallpaperRadioChange">
            <el-radio :label="0">{{$t('messageAdd.display.005')}}</el-radio>
            <el-radio :label="1">{{$t('messageAdd.display.007')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.display.008')" v-show="wallpaperForm.t===1">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="#"
            :limit="1"
            accept=".png,.jpg,.jpeg"
            :on-change="handleWallpaperChange"
            :on-remove="handleWallpaperRemove"
            :on-exceed="handleWallpaperExceed"
            :file-list="fileList"
            list-type="picture"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">{{ $t('messageAdd.display.009') }}</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitWallpaperUpload">{{ $t('messageAdd.display.010') }}</el-button>
            <template slot="tip">
              <div class="el-upload__tip">
                <p>{{ $t("messageAdd.note.005") }}</p>
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.display.006')" v-show="wallpaperForm.t===0">
          <el-input v-model="wallpaperForm.url" :placeholder="$t('messageAdd.display.006')+'https:\/\/(http:\/\/)'" style="width: 350px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeWallpaperDialog">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveWallpaper">{{ $t("common.submit") }}</el-button>
      </div>
    </el-dialog>

    <!-- 添加应用弹框 -->
    <el-dialog :title="$t('message.mobileButlerMsg.addApp')" :visible.sync="appDialogVisible" width="40%"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-width="150px" :rules="appRules" :model="appData" ref="addAppForm" class="custom-form">
        <el-form-item label="Package Name" prop="package_name">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="appData.package_name"></el-input>
        </el-form-item>
        <el-form-item label="Class Name" prop="class_name">
          <el-input :placeholder="$t('common.pleaseInput')" v-model="appData.class_name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.mobileButlerMsg.showOnDesktop')">
          <el-select v-model="appData.show_on_desktop" >
            <el-option :label="$t('common.open')" :value="true"></el-option>
            <el-option :label="$t('common.close')" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancelAddApp">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveAddApp">{{ $t("common.submit") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {uploadFile} from "@/api/stage";
export default {
  props: {
    mobileButler: {
      type: Object,
      default: () => ({
        DeleteConfig: {
          delete_all: false,
          delete_app_info: false,
        },
        AppList: [],
        auto_start_app: {
          package_name: "",
          class_name: "",
        },
        Setting: {
          account_info: {
            user_name: "",
            password: "",
          },
          password_protection: {
            question: "",
            answer: "",
            answer_type: "",
          },
          allow_new_app_auto_add: false,
          boot_startup: false,
        },
        wp: {},
      }),
    },
  },
  data() {
    return {
      appDialogVisible: false,
      appData: {
        package_name: "",
        class_name: "",
        show_on_desktop: true,
      },

      wallpaperDialogVisible: false,
      wallpaperForm: {
        file: null,
        t: 0, // 0: URL, 1: File
        url: '',
        id: '',
        md5: '',
        name: '', // 文件名
        suffix: '', // 文件后缀
      },
      fileList: [],
      wallpaperRules: {},
    };
  },
  computed: {
    m() {
      return this.mobileButler;
    },
    appRules() {
      return {
        package_name: [
          {
            required: true,
            message: this.$t("message.messageMsg.inputPackageName"),
            trigger: "change",
          },
        ],
        class_name: [
          {
            required: true,
            message: this.$t("message.messageMsg.inputClassName"),
            trigger: "change",
          },
        ],
      };
    },
  },
  watch: {
    m: {
      handler(newVal) {
        this.$emit("update:mobileButler", newVal);
        this.$emit("update:config-mobile-butler", newVal);
      },
      deep: true,
    },
  },
  methods: {
    // 打开添加应用弹框
    openAddAppDialog() {
      this.appData = {
        package_name: "",
        class_name: "",
        show_on_desktop: null,
      };
      this.appDialogVisible = true;
    },
    // 取消添加应用
    cancelAddApp() {
      this.appData = {
        package_name: "",
        class_name: "",
        show_on_desktop: true,
      };
      this.appDialogVisible = false;
      this.$refs["addAppForm"].clearValidate();
    },
    // 保存添加应用
    saveAddApp() {
      this.$refs["addAppForm"].validate((valid) => {
        if (valid) {
          this.m.AppList.push({
            AppInfo: { ...this.appData },
          });
          this.appDialogVisible = false;
          this.$message({
            message: this.$t("common.add_success"),
            type: "success",
          });
        }
      });
    },
    // 删除应用
    handleAppClose(index) {
      if (this.m.AppList.length > 0) {
        this.m.AppList.splice(index, 1);
      }
    },
    // 校验五个联动必填字段
    validateRequiredFields() {
      const account = this.m.Setting?.account_info || {};
      const protection = this.m.Setting?.password_protection || {};
      const userName = account.user_name || "";
      const password = account.password || "";
      const question = protection.question || "";
      const answer = protection.answer || "";
      const answerType = protection.answer_type || "";

      const fields = [userName, password, question, answer, answerType];
      const hasAny = fields.some((f) => f !== "");
      const hasAll = fields.every((f) => f !== "");

      // 要么五个都填，要么五个都不填
      if (!hasAny || hasAll) {
        return true;
      }

      this.$message.warning(this.$t('message.messageMsg.screenSaverTips'));
      return false;
    },

    // 壁纸设置
    manageWallpaper() {
      this.wallpaperDialogVisible = true;
      this.$nextTick(() => {
        if (this.m.wp) {
          this.wallpaperForm.t = this.m.wp.t !== undefined ? this.m.wp.t : 0;
          if(this.wallpaperForm.t === 0) {
            this.wallpaperForm.url = this.m.wp.url || '';
          } else if(this.wallpaperForm.t === 1) {
            this.wallpaperForm.url = this.m.wp.url || '';
            this.wallpaperForm.id = this.m.wp.id || '';
            this.wallpaperForm.md5 = this.m.wp.md5 || '';
            this.wallpaperForm.name = this.m.wp.an || '';
            this.wallpaperForm.suffix = this.m.wp.bn || '';
            this.fileList = [{
              name: this.wallpaperForm.name+'.'+this.wallpaperForm.suffix,
              url: this.wallpaperForm.url,
            }];
            this.wallpaperForm.file = null;
          }
        } else {
          this.handleWallpaperRadioChange(0);
        }
      });
    },
    closeWallpaperDialog() {
      this.wallpaperDialogVisible = false;
    },
    handleWallpaperRadioChange(value) {
      // 切换上传方式时，清空之前的输入
      this.wallpaperForm.file = null;
      this.wallpaperForm.url = '';
      this.wallpaperForm.id = '';
      this.wallpaperForm.md5 = '';
      this.wallpaperForm.name = '';
      this.wallpaperForm.suffix = '';
      this.fileList = [];
      this.$refs.upload && this.$refs.upload.clearFiles();
    },
    handleWallpaperChange(file, fileList) {
      const isJPG = file.raw.type === 'image/jpeg';
      const isPNG = file.raw.type === 'image/png';
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isJPG && !isPNG) {
        this.$message.error(this.$t('messageAdd.display.011'));
        this.fileList = [];
        this.wallpaperForm.file = null;
        this.$refs.upload && this.$refs.upload.clearFiles();
        return;
      }
      if (!isLt10M) {
        this.$message.error(this.$t('messageAdd.display.012'));
        this.fileList = [];
        this.wallpaperForm.file = null;
        this.$refs.upload && this.$refs.upload.clearFiles();
        return;
      }

      this.wallpaperForm.file = file.raw;
      this.wallpaperForm.id = '';
      this.wallpaperForm.md5 = '';
      this.wallpaperForm.url = '';
      this.wallpaperForm.name = '';
      this.wallpaperForm.suffix = '';
      this.fileList = fileList;
    },
    handleWallpaperRemove(file, fileList) {
      this.wallpaperForm.file = null;
      this.wallpaperForm.id = '';
      this.wallpaperForm.md5 = '';
      this.wallpaperForm.url = '';
      this.wallpaperForm.name = '';
      this.wallpaperForm.suffix = '';
      this.fileList = fileList;
    },
    handleWallpaperExceed() {
      this.$message.warning(this.$t('messageAdd.display.015'));
    },
    submitWallpaperUpload() {
      if (!this.wallpaperForm.file) {
        this.$message.error(this.$t('messageAdd.display.013'));
        return;
      }
      let formData = new FormData();
      formData.append('fileList', this.wallpaperForm.file);
      formData.append('type', 4);
      const loading = this.$loading({
        lock: true,
        text: this.$t('messageAdd.manageCert.049'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      uploadFile(formData, 4).then(res => {
        if (res.success) {
          loading.close();
          this.wallpaperForm.id = res.data[0].id;
          this.wallpaperForm.md5 = res.data[0].md5;
          this.wallpaperForm.url = res.data[0].url;
          this.wallpaperForm.name = res.data[0].name;
          this.wallpaperForm.suffix = res.data[0].suffix;
          this.$message.closeAll();
          this.$message.success(this.$t('messageAdd.manageCert.050'));
        } else {
          loading.close();
          this.$message.closeAll();
          this.$message.error(this.$t(`code.${res.errorCode}`) + (res.errorInfo ? res.errorInfo : ''));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('common.operate_fail'));
      });
    },
    saveWallpaper() {
      if (this.wallpaperForm.t === 1) {
        if (!this.wallpaperForm.id) {
          this.$message.error(this.$t('messageAdd.display.014'));
          return;
        }
        if (!this.wallpaperForm.url) {
          this.$message.error(this.$t('messageAdd.display.013'));
          return;
        }
        this.$set(this.m, 'wp', {
          t: 1,
          id: this.wallpaperForm.id,
          url: this.wallpaperForm.url,
          md5: this.wallpaperForm.md5,
          an: this.wallpaperForm.name,
          bn: this.wallpaperForm.suffix
        });
      } else {
        if (!this.wallpaperForm.url) {
          this.$message.error(this.$t('messageAdd.display.016'));
          return;
        }
        this.$set(this.m, 'wp', {
          t: 0,
          url: this.wallpaperForm.url
        });
      }
      this.wallpaperDialogVisible = false;
      this.$message.success(this.$t('common.operate_success'));
    }
  },
};
</script>

<style lang="less" scoped>
.upload-demo {
  width: 350px;
}
.el-upload__tip {
  line-height: normal;
}
</style>
